/**
 * @module utils/time-restricted
 * @description Shared methods for displaying features (including walls) with date/time restrictions
 */
import { areChronologicalEpochs, formatEpoch } from "utils/utils";
import logger from "utils/logger";

const debugTag = "[TIME-RESTRICTED-FEATURE]";

/**
 * @method isTimedEnabledFeature
 * @description Checks to see if this feature should be enabled within the start and end time.
 * @param {Object} params - parameters
 * @param {Number} params.start - epoch start time
 * @param {Number} params.now - to compare against the start and end range
 * @param {Number} params.end - epoch end time
 * @returns {Boolean} true when feature is enabled
 */
export function isTimedEnabledFeature({ start, now, end }) {
  const withinDateTimeRange = areChronologicalEpochs(start, now, end, true);

  logger.info(`${debugTag} suppressed - outside of date/time range:`, !withinDateTimeRange, {
    start: `${start} - ${formatEpoch(start)}`,
    now: `${now} - ${formatEpoch(now)}`,
    end: `${end} - ${formatEpoch(end)}`,
    within: withinDateTimeRange // true when within the datetime range
  });

  return withinDateTimeRange;
}
